/**
 * Actions in the edit-locking lifecycle.
 */
export enum Action {
    EDIT = 'edit',
    SAVE = 'save',
    CONFIRM = 'confirm',
    REVERT = 'revert',
}

/**
 * Component types for the entity-draft locking API.
 * Mirrors the backend ComponentType enum.
 */
export const LOCK_COMPONENT_TYPES = {
    CALCULATION: 'CALCULATION',
    MDA_WORKSHEET: 'MDA_WORKSHEET',
    TPA_WORKSHEET: 'TPA_WORKSHEET',
    TPA_WORKSHEET_TEMPLATE: 'TPA_WORKSHEET_TEMPLATE',
} as const;

export type LockComponentType = typeof LOCK_COMPONENT_TYPES[keyof typeof LOCK_COMPONENT_TYPES];

/**
 * Values for the lockedByEntityType field in LockInfo responses.
 * Indicates what kind of entity holds the lock.
 */
export const LOCK_SOURCE = {
    USER: 'USER',
    TPA_WORKSHEET: 'TPA_WORKSHEET',
    TPA_WORKSHEET_TEMPLATE: 'TPA_WORKSHEET_TEMPLATE',
} as const;

export type LockSource = typeof LOCK_SOURCE[keyof typeof LOCK_SOURCE];

/**
 * Default user-facing messages for lock actions.
 * These can be overridden per entity type via useLockActions config.
 */
export const DEFAULT_LOCK_MESSAGES = {
    editSuccess: 'You are now editing.',
    saveSuccess: 'Changes saved.',
    confirmSuccess: 'Changes confirmed.',
    revertSuccess: 'Changes reverted.',
    editFailure: 'Failed to start editing',
    saveFailure: 'Failed to save',
    confirmFailure: 'Failed to confirm',
    revertFailure: 'Failed to revert',
    lockedByOther: (lockedBy: string) => `This entity is locked by ${lockedBy}.`,
    disabledReason: 'Click Edit to make changes.',
};

export type LockMessages = typeof DEFAULT_LOCK_MESSAGES;
